
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Technische Hinweise</div>
    <p>{`Die Gefahrenkarten der einzelnen Kantone wurden vom Tamedia-Datenteam von den jeweiligen Kantonen in elektronischer Form beschafft und in eine einheitliche Form gebracht. Die dargestellten Naturgefahren stellen den Stand zum Zeitpunkt des Bezugs von den Kantonen dar (unten in der Tabelle aufgeführt). Die Karte wird nicht aktualisiert. Ausschlaggebend sind immer die Originaldaten des jeweiligen Kantons. Diese können auf den Geoportalen der jeweiligen Kantone betrachtet werden, die Links dazu finden sich ebenfalls in der untenstehenden Tabelle. Teilweise sind in den kantonalen Geoportalen noch mehr Angaben zu finden, zum Beispiel Karten für weitere Gefahren wie Steinschlag und Erdrutsch oder auch Gefahrenhinweiskarten für Bereiche ausserhalb der Siedlungsgebiete. In den Kantonen Solothurn, Jura, Zug, Tessin und Graubünden gibt es einzelne Gebiete, die noch nicht erfasst wurden. Dies kann auf der Seite des `}<a href='https://www.bafu.admin.ch/bafu/de/home/themen/naturgefahren/fachinformationen/naturgefahrensituation-und-raumnutzung/gefahrengrundlagen/gefahrenkarten--intensitaetskarten-und-gefahrenhinweiskarten.html'>{`Bundesamts für Umwelt`}</a>{` nachgeschaut werden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;